import React from "react";
import Navbar from "../components/navbar";
import Hero from "../components/hero";
import Footer from "../components/footer";

const Home = () => {
  return (
    <div className="bg-[#0f1829] min-h-[100vh] w-full flex flex-col">
      <Navbar />
      <Hero />
      <Footer />
    </div>
  );
};

export default Home;
